import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Paging = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb404__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb404__a)">
            <path
              fillRule="evenodd"
              d="M11 12H5a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Zm16 0h-6a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Zm16 0h-6a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Zm0 14H5a2 2 0 1 1 0-4h38a2 2 0 1 1 0 4ZM11 40H5a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Zm16 0h-6a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Zm16 0h-6a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
